import { FC } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface DisconnectDialogProps {
    open: boolean;
    onLeaveNotFinishing: () => void;
    onLeaveFinishingEvent: () => void;
    onDismiss: () => void;
}

const DisconnectDialog: FC<DisconnectDialogProps> = ({
    open,
    onLeaveNotFinishing,
    onLeaveFinishingEvent,
    onDismiss,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onDismiss}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>{t('Finish event')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography>
                        {t(
                            'Are you sure you want to finish the event? If you finish the event all the viewers will be disconnected and the event will not be open again.',
                        )}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onLeaveNotFinishing}>Leave not finishing event</Button>
                <Button onClick={onLeaveFinishingEvent}>Finish event</Button>
                <Button onClick={onDismiss} autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DisconnectDialog;
